export enum FilterOptions {
  ACTIVE = 'active',
  ALL = 'all',
  INACTIVE = 'inactive'
}

export enum TextColors {
  BLACK = 'black',
  WHITE = 'white'
}

export enum IconCategory {
  standard = 'standard',
  retail = 'retail',
  hospitality = 'hospitality',
  numbers = 'numbers'
}

export interface TaskIcon {
  icon: string;
  customText?: string;
  category: IconCategory;
}

export interface TaskType {
  id: string;
  name: string;
  displayName: string;
  icon: TaskIcon;
  textColor: TextColors;
  color: string;
  defaultDuration: number;
  isSupplementary: boolean;
  isInMonthlyTotals: boolean; // STRONGLY SUSPECT THIS DOESN'T DO ANYTHING
  isInCalculatedWorkingHours: boolean;
  skills: string[];
  optionalSkills: string[];
  isActive: boolean;
}
